import React from 'react'

const HeaderSocials = () => {
    return (
       <div className="home__socials">
         <a href="https://www.instagram.com/efsalgl/" className="home__social-link" target="_blank" rel="noreferrer">
          <i className="fa-brands fa-instagram"></i>
         </a>
         
         <a href="https://www.linkedin.com/in/efsa-dilşat-algül-71a014117/" className="home__social-link" target="_blank" rel="noreferrer">
          <i className="fa-brands fa-linkedin"></i>
         </a>
         
         <a href="https://www.instagram.com/efsa.art/" className="home__social-link" target="_blank" rel="noreferrer">
          <i className="fa-brands fa-instagram"></i>
         </a>
       </div>
    )
}

export default HeaderSocials